import { MagicWand, X } from "@phosphor-icons/react";

export default function JdModal({ jd, setJd, tailoring, onSubmit, onClose }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" data-testid="jd-modal">
      <div className="bg-white w-full max-w-2xl border border-black/10">
        <div className="flex items-center justify-between p-4 border-b border-black/10">
          <div className="flex items-center gap-2">
            <MagicWand size={16} weight="bold" className="text-[#FF2A00]" />
            <span className="font-heading font-semibold">Match resume to a job description</span>
          </div>
          <button onClick={onClose} className="text-neutral-500 hover:text-black" data-testid="jd-close">
            <X size={16} />
          </button>
        </div>
        <div className="p-4">
          <div className="label-mono mb-2">Paste job description</div>
          <textarea
            className="field-textarea min-h-[220px] w-full"
            value={jd}
            onChange={(e) => setJd(e.target.value)}
            placeholder="Paste the full JD here — responsibilities, requirements, keywords…"
            data-testid="jd-textarea"
          />
          <div className="mt-2 text-xs text-neutral-500">
            AI will rewrite your summary and bullets to match keywords without inventing facts, and suggest a template.
          </div>
        </div>
        <div className="p-4 border-t border-black/10 flex justify-end gap-2">
          <button onClick={onClose} className="btn-secondary" data-testid="jd-cancel">Cancel</button>
          <button onClick={onSubmit} disabled={tailoring} className="btn-primary" data-testid="jd-submit">
            <MagicWand size={14} weight="bold" />
            {tailoring ? "Tailoring…" : "Tailor my resume"}
          </button>
        </div>
      </div>
    </div>
  );
}
